export default __webpack_public_path__ + "static/flicker-5f81effbc5f5e5ce9e826000f5f71d32.woff";